import { Position } from 'modules/graphql/types';
import {
  fadeInStyles,
  fadeOutStyles,
  slideInStyles,
  slideOutStyles,
  slideDownBottomStyles,
  slideDownTopStyles,
  slideUpBottomStyles,
  slideUpTopStyles,
} from './styles';
import { ANIMATION, IN_APP_VIEW_OPTIONS } from '../constants';

/** Copied from WebInApp */
export const generateAnimationStyles = (
  animation: ANIMATION | null,
  position: Position,
  display: IN_APP_VIEW_OPTIONS,
) => {
  if (!animation) {
    return '';
  }
  if (animation === ANIMATION.slideOut) {
    if (display === IN_APP_VIEW_OPTIONS.web) {
      /* in-apps using the Iterable Web SDK slide from left to right */
      return slideOutStyles;
    }

    /* 
      otherwise on native SDKs they 
      slide out to the top or out to the bottom depending
      on where the in-app is positioned
    */
    if (position === Position.Bottom) {
      return slideDownBottomStyles;
    }

    if (position === Position.Top) {
      return slideDownTopStyles;
    }
  }

  if (animation === ANIMATION.slideIn) {
    if (display === IN_APP_VIEW_OPTIONS.web) {
      /* 
        same comment as above. on the Web SDK, the message
        is going to slide in from the side
      */
      return slideInStyles;
    }

    /*
      or if it's a native app using a mobile SDK, 
      it's going to slide up or down
    */
    if (position === Position.Bottom) {
      return slideUpBottomStyles;
    }

    if (position === Position.Top) {
      return slideUpTopStyles;
    }
  }

  /*
    however both web and native SDKS both fade in/out centered and full
    screen in-apps
  */
  if (animation === ANIMATION.fadeIn) {
    return fadeInStyles;
  }

  if (animation === ANIMATION.fadeOut) {
    return fadeOutStyles;
  }

  return {};
};
export const generatePositionStyles = (
  isWebPreview: boolean,
): Record<Position, Record<string, number | string>> => ({
  [Position.Full]: {
    height: '100%',
    width: '100%',
  },
  [Position.Center]: {
    top: '50%',
    transform: 'translate(0px, -50%)',
    insetInline: isWebPreview ? '20%' : '',
    maxHeight: '100%',
    writingMode: isWebPreview ? 'horizontal-tb' : '',
    minWidth: isWebPreview ? '60%' : '100%',
    maxWidth: isWebPreview ? '70%' : '100%',
  },
  [Position.Top]: {
    right: 0,
    top: 0,
    maxHeight: '100%',
    minWidth: isWebPreview ? '60%' : '100%',
    maxWidth: isWebPreview ? '70%' : '100%',
  },
  [Position.Bottom]: {
    right: 0,
    bottom: 0,
    maxHeight: '100%',
    minWidth: isWebPreview ? '60%' : '100%',
    maxWidth: isWebPreview ? '70%' : '100%',
  },
});
